/** @format */

import { TLocale } from '@/utils/gatsby/types';
import { SITE_URL } from '../gatsby/constants';
import { utilityCalculateBreadCrumbs } from './calculateBreadCrumbs';

export const utilityGetJsonLdBreadCrumbs = (
  path: string,
  language: TLocale,
  listingUrl?: string,
  removeItem?: string,
) => {
  const breadCrumbsItem = utilityCalculateBreadCrumbs(path, language, listingUrl, removeItem);

  const list = breadCrumbsItem.map(item => ({
    '@type': 'ListItem',
    position: item.position,
    item: {
      '@id': `${SITE_URL}${item.url}`,
      name: item.name.replace(/_|-/g, ' '),
      active: item.active,
    },
  }));

  const ldJson = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: list,
    numberOfItems: list.length,
  };

  return ldJson;
};
